import { Box, DividerProps, Divider as MuiDivider } from "@mui/material";
import React from "react";

interface Props extends DividerProps {
  children?: React.ReactNode;
}

export function Divider(props: Props) {
  const styles = useStyles();
  let { children, ...restProps } = props;

  return (
    <MuiDivider {...restProps} sx={{ ...styles.divider }}>
      <Box width={"100%"} height={"fit-content"}>
        {React.isValidElement(children) ? children : null}
      </Box>
    </MuiDivider>
  );
}

function useStyles() {
  return {
    divider: {
      position: "relative",
      "&:before": {
        width: 0,
      },
      "& .MuiDivider-wrapper": {
        padding: 0,
        width: "100% !important",
        position: "absolute",
        transform: "translateY(-50%)",
      },
    },
  };
}
